import React from 'react';
import { useState } from 'react';
import { UseAppSelector, UseAppDispatch } from '../../../store/hooks';
import { updateLocation, calcTC, calcPP } from '../../../store/statsEngine';
import { PlusCircle, DashCircle } from 'react-bootstrap-icons';
import { Slide } from 'react-reveal';
import Accordion from 'react-bootstrap/Accordion';
import FormatCurrency from '../../../scripts/formatCurrency';

import 'bootstrap/dist/css/bootstrap.css';
import '../../../styles/mobile/calculators/locationSelectMobile.css';

function LocationSelectMobile() {
    const dispatch = UseAppDispatch();

    // UI states
    const [filterState, setFilterState] = useState('free');
    const [locationState, setLocationState] = useState(1);

    // redux
    const statsEngine = UseAppSelector((state) => state.stats);
    const dataObject = statsEngine.find(item => item.id === 21);
    const data = dataObject.data;

    const locationsFilters = data.find(item => item.id === 0);
    const selectedLocation = data.find(item => item.id === parseInt(locationState));

    // click handlers
    function handleLocationClick(value) {
        dispatch(updateLocation({ value: value }));
        dispatch(calcTC({}));
        dispatch(calcPP({}));
    }

    handleLocationClick(selectedLocation.cost);

    return (
        <section className="mobile-location-section">
            <div className="calulator-title">
                <h2>- Location Select -</h2>
            </div>

            <Slide bottom>
                <div className="mobile-location-parent">
                    <div className="mobile-info-display">
                        <h1>{selectedLocation.title}</h1>
                        <h1>GTA {FormatCurrency(selectedLocation.cost)}</h1>
                    </div>

                    <div className="mobile-map-display">
                        <img className="location-img" src={selectedLocation.image} alt="..."></img>
                    </div>

                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                Location Filters
                                <PlusCircle className="plus-circle"/>
                                <DashCircle className="dash-circle"/>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="filter-btns">
                                    <input type="radio" value="free" onClick={e => setFilterState(e.target.value)} name="filter-opt" id="opt-1" defaultChecked></input>
                                    <label htmlFor="opt-1">{locationsFilters.filter_title1}</label>

                                    <input type="radio" value="under" onClick={e => setFilterState(e.target.value)} name="filter-opt" id="opt-2"></input>
                                    <label htmlFor="opt-2">{locationsFilters.filter_title2}</label>

                                    <input type="radio" value="over" onClick={e => setFilterState(e.target.value)} name="filter-opt" id="opt-3"></input>
                                    <label htmlFor="opt-3">{locationsFilters.filter_title3}</label>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>
                                Location Choices
                                <PlusCircle className="plus-circle"/>
                                <DashCircle className="dash-circle"/>
                            </Accordion.Header>
                            <Accordion.Body>
                                {data.filter(info => info.category === filterState).map(filteredCategory => (
                                    <div key={filteredCategory.id} className="item-container">
                                        <input type="radio" name="select" onClick={e => setLocationState(e.target.id)} id={filteredCategory.id}></input>
                                        <label htmlFor={filteredCategory.id}>
                                            <div className="dot"></div>
                                            <div className="text">{filteredCategory.title}</div>
                                        </label>
                                    </div>
                                ))}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Slide>
        </section>
    )
}

export default LocationSelectMobile;